<!-- 搜汽配 -->
<template>
    <div id="qpSearch" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>汽配快搜</el-breadcrumb-item>
                <el-breadcrumb-item>搜汽配</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">汽配编码:</div>
            <el-input
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.Code"
                    placeholder="请输入汽配编码">

            </el-input>
            <div class="search-name">汽配名称:</div>
            <el-input
                    class="search-item"
                    size="small"
                    v-model.trim="searchData.Name"
                    placeholder="请输入汽配名称">

            </el-input>
            <div class="search-name">车系:</div>
            <el-input
                    style="width: 200px !important;"
                    class="search-item"
                    size="small"
                    v-model="carType"
                    placeholder="请选择车系"
                    @focus="showDialog(1)"
                    readonly
            >
            </el-input>
            <el-button type="primary" size="small" icon="el-icon-search" class="search-btn" @click="handleSearch">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-refresh" class="search-btn" @click="resetSearch">重置</el-button>
        </div>
        <div class="qp-ctn">
            <el-card class="box-card qp-item" v-for="item in tableData" :key="item.Id">
                <div class="qp-cover">
                    <img :src="QN_URL_BASE + item.PublicUrl" alt="" :onerror="defaultImg">
                </div>
                <div class="qp-msg">
                    <p>汽配名称：{{item.Cn}}</p>
                    <p>编码：{{item.Code}}</p>
                    <p class="ops-ctn">
                        <el-button size="mini" @click="showDialog(3,item)" v-if="permission.创建询价单">创建询价单</el-button>
                        <el-button size="mini" @click="showDialog(2,item)" v-if="permission.推送">推送</el-button>
                    </p>
                </div>
            </el-card>
            <div class="no-data" v-if="noData">
                无搜索结果
            </div>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[12, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength">
            </el-pagination>
        </div>
        <el-dialog
                :before-close="dialogClose"
                :title="dialogTitle"
                :visible.sync="dialogVisible"
                width="800px"
        >   <div class="dialog-content">
            <!-- 选择车系 -->
            <template v-if="dialogType==1">
                    <chooseCarType @chooseCar="chooseCar" ref="chooseCarType"></chooseCarType>
            </template>
            <!-- 推送商品 -->
            <template v-else-if="dialogType==2">
                <push @closeDialog="closeDialog" ref="push" :goodMsg="choosedGood"></push>
            </template>
            <!-- 创建询价单 -->
            <template v-else-if="dialogType==3">
                <createAskFrom @closeDialog="closeDialog" :goodMsg="choosedGood" ref="createAskFrom"></createAskFrom>
            </template>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import chooseCarType from '@/components/business/search/chooseCarType.vue'
    import push from '@/components/business/search/push.vue'
    import createAskFrom from '@/components/business/search/createAskFrom.vue'
    export default {
        name: 'qpSearch',
        components: {
            chooseCarType,
            push,
            createAskFrom
        },
        data() {
            return {
                noData:false,
                QN_URL_BASE:this.$util.QN_URL_BASE,
                defaultImg:'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
                choosedGood:{},
                dialogType:3,
                dialogTitle:'',
                dialogVisible:false, // dialog显隐
                carType:'',
                searchData: {
                    Code: '',
                    Name: '',
                    SId: '',
                    page:1, // 当前页数
                    limit:12, // 每页限制条数
                    key:'', //关键字查询
                },
                tableData: [],
                tableDataLength:0,
                permission:{} // 拥有权限
            }
        },
        mounted() {
            this.getTableData()
            this.$util.getPermission('搜汽配').then((res)=>{
                this.permission = res
            })
        },
        methods: {
            // 重置查询条件
            reset(){
                this.searchData = {
                    Code: '',
                    Name: '',
                    SId: '',
                    page:1, // 当前页数
                    limit:12, // 每页限制条数
                    key:'', //关键字查询
                }
                this.carType = ''
            },
            // 弹窗关闭触发
            dialogClose(){
                //清空表单
                if(this.dialogType==1){
                    this.$refs.chooseCarType.resetForm();
                }
                if(this.dialogType==3){
                    this.$refs.createAskFrom.resetForm();
                    this.choosedGood = {}
                }
                this.dialogVisible = false
            },
            closeDialog(){
                this.dialogVisible = false
            },
            getTableData(){
                this.axios.get('/AutoParts/LoadAutoParts',{
                    params: this.searchData

                })
                    .then((response)=> {
                        if(response.data.count == 0){
                            this.noData = true
                        }
                        else {
                            this.noData = false
                        }
                        this.tableData = response.data.data
                        this.tableDataLength = response.data.count
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            // 选车型
            chooseCar(parms){
                let showData = parms.slice(0,2)
                let sendData = parms.slice(2,3)
                let result = showData.join('/')
                this.searchData.SId = sendData[0]
                this.carType =result
                this.$refs.chooseCarType.resetForm();
                this.dialogVisible = false
            },
            showDialog(type,item){
                if (item){
                    this.choosedGood = item
                }
                if(type == 1){
                    this.dialogTitle = '选择车系'
                }
                else if (type == 2){
                    if (this.$store.state.connectState != 2){
                        this.$message({
                            message: '请先连接到客服并接入客户',
                            type: 'warning'
                        });
                        return
                    }
                    this.dialogTitle = '推送'
                }
                else if (type == 3){
                    if (this.$store.state.connectState != 2){
                        this.$message({
                            message: '请先连接到客服并接入客户',
                            type: 'warning'
                        });
                        return
                    }
                    this.dialogTitle = '创建询价单'
                }
                this.dialogType = type
                this.dialogVisible = true;
            },
            handleSearch(){
                this.searchData.page = 1
                this.getTableData()
            },
            resetSearch(){
                this.searchData = {
                    Code: '',
                    Name: '',
                    SId: this.$util.getSessionStorage('userMsg').Id,
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                    key:'', //关键字查询
                }
                this.carType = ''
            },
            handleSizeChange(val) {
                this.searchData.limit = val
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.searchData.page = val
                this.getTableData()
            }
        }
    }
</script>
<style lang="less" scoped>
    .qp-ctn {
        display: flex;
        flex-wrap: wrap;
    }



    .ops-ctn {
        padding-top: 20px;
        display: flex;
        justify-content: flex-end;
    }
    .dialog-content {
        max-height: 600px;
        overflow: auto;
    }
    .no-data {
        width: 100%;
        padding: 100px;
        text-align: center;
        font-size: @font-lg;
        color: @font4Color;
    }
</style>
<style lang="less">
    .qp-item {
        .el-card__body {
            padding: 0;
        }
    }
</style>
